import { Injectable, inject } from '@angular/core'
import { CdcTokenResponse } from '@app/core/models/custom/auth.model'
import { GigyaAuthData } from '@app/core/models/custom/gigya.model'
import { Command, CommandService, CommandStrategy } from '@spartacus/core'
import { Observable } from 'rxjs'
import { CustomAuthConnector } from './auth.connector'

@Injectable({ providedIn: 'root' })
export class CustomAuthFacade {
  private readonly command = inject(CommandService)
  private readonly authConnector = inject(CustomAuthConnector)

  private getCdcTokenCommand: Command<GigyaAuthData, CdcTokenResponse> = this.command.create(
    data => this.authConnector.getCdcToken(data),
    { strategy: CommandStrategy.Queue }
  )

  getCdcToken (authData: GigyaAuthData): Observable<CdcTokenResponse> {
    return this.getCdcTokenCommand.execute(authData)
  }
}
